// Gemeinsame Firebase-Instanz für die gesamte App.
//
// Hier wird bewusst nur firebase/database importiert. Auth und Storage
// braucht ausschließlich der Admin-Bereich; die Module werden dort per
// dynamischem Import nachgeladen, damit sie nicht im Bundle der
// öffentlichen Seite landen.

import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';

const firebaseConfig = {
  apiKey: 'AIzaSyDgeB-u0DUI9QFj-ZDUr2vOLW3eaVUIBRk',
  authDomain: 'augenstern-schmuck.firebaseapp.com',
  databaseURL: 'https://augenstern-schmuck.firebaseio.com',
  projectId: 'augenstern-schmuck',
  storageBucket: 'augenstern-schmuck.appspot.com',
  messagingSenderId: '306918481442',
  appId: '1:306918481442:web:6403ea81d182425a79747b',
  measurementId: 'G-LJ52Y2VEYE',
};

const app = initializeApp(firebaseConfig);
const database = getDatabase(app);

export { app, database, firebaseConfig };
